export default function Coupon() {
    return (
        <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.75 15.1667H20.3333" stroke="#3F68E0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M20.3333 18.6667H12.75" stroke="#3F68E0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.75 11.6667H20.3333V8.16675H12.75V11.6667Z"
                stroke="#3F68E0"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M8.6665 15.3352H5.1665V21.336C5.16992 22.4395 6.06326 23.3328 7.16676 23.3362"
                stroke="#3F68E0"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.3339 4.66675C9.68958 4.66675 9.16725 5.18908 9.16725 5.83341V21.3357C9.16383 22.4388 8.27049 23.3325 7.16699 23.3359H21.8356C22.9388 23.3325 23.8325 22.4388 23.8355 21.3357V5.83342C23.8355 5.18908 23.3132 4.66675 22.6689 4.66675H10.3339Z"
                stroke="#3F68E0"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
}
